module.exports = __webpack_public_path__ + "ce1e89f5cba108dee86f2f0c699f19ae.png";